import { useEffect } from "react";
import { useSidebar } from "../SidebarContext";

const SIDEBAR_KEYBOARD_SHORTCUT = "b";

export function useSidebarKeyboard(collapsed) {
    const { toggleSidebar } = useSidebar();

    useEffect(() => {
        function handleKeyDown(event) {
            if (event.isComposing || event.keyCode === 229) {
                return;
            }

            if (event.key?.toLowerCase() !== SIDEBAR_KEYBOARD_SHORTCUT || (!event.metaKey && !event.ctrlKey)) {
                return;
            }

            event.preventDefault();
            toggleSidebar();
        }

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [collapsed, toggleSidebar]);
}
